export default __webpack_public_path__ + "static/media/SamsungInterFace-Regular.b0ec18f8.ttf";